import { ALL_STUDIES_LABEL, ArticleChipItem, StudyChipItem } from './FilterChips.types';

export const getStudyConditionLabel = (item: StudyChipItem): string | null => {
  const related = item?.fields?.relatedTrial;
  if (!related || typeof related === 'string') {
    return null;
  }
  const value = related.fields?.featuredTrialCondition?.fields?.description?.value;
  if (value == null || value === '') {
    return null;
  }
  return value;
};

export const getStudyNavigateHref = (item: StudyChipItem): string | undefined => {
  const href = item?.fields?.trialCTA?.value?.href;
  if (href == null || href === '') {
    return undefined;
  }
  return String(href);
};

export const getConditionLabel = getStudyConditionLabel;

export const getArticleConditionLabel = (item: ArticleChipItem): string | null => {
  const value = item?.fields?.articleConditions?.fields?.description?.value;
  if (value == null || value === '') {
    return null;
  }
  return String(value);
};

export const getArticleNavigateHref = (item: ArticleChipItem): string | undefined => {
  const url = item?.url;
  if (url == null || url === '') {
    return undefined;
  }
  return url;
};

export function buildChipLabels<T>(
  items: T[],
  getConditionLabel: (item: T) => string | null,
  allLabel: string = ALL_STUDIES_LABEL
): string[] {
  const uniqueLabels = [
    ...new Set(items.map(getConditionLabel).filter((label): label is string => label !== null)),
  ].sort((a, b) => a.localeCompare(b));

  return [allLabel, ...uniqueLabels];
}

export function filterItemsByChip<T>(
  items: T[],
  chip: string,
  getConditionLabel: (item: T) => string | null,
  allLabel: string = ALL_STUDIES_LABEL
): T[] {
  if (chip === allLabel) {
    return items;
  }

  return items.filter((item) => getConditionLabel(item) === chip);
}
